export * from './lib/tooltip.module';
export * from './lib/tooltip.interface';
